import api from "../../config/client.axios.api";

export const deleteSolutionApi = async (id: any) => {
  const response = await api.delete(`/solution?solution_id=${id?.id}`);
  return response.data;
};
